/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPokeball = createReactComponent("outline", "pokeball", "IconPokeball", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M3 12h6", "key": "svg-2" }], ["path", { "d": "M15 12h6", "key": "svg-3" }]]);

export { IconPokeball as default };
//# sourceMappingURL=IconPokeball.mjs.map
